import React from 'react';
import { createPortal } from 'react-dom';
import type { ReportFormat } from '../api/validate.api';

interface ExportMenuProps {
  menuRef: React.RefObject<HTMLDivElement>;
  pos: { top: number; right: number };
  onExport: (format: ReportFormat) => void;
}

export function ExportMenu({ menuRef, pos, onExport }: ExportMenuProps) {
  return createPortal(
    <div
      ref={menuRef}
      className="rp__export-menu"
      style={{ '--rp-menu-top': `${pos.top}px`, '--rp-menu-right': `${pos.right}px` } as React.CSSProperties}
    >
      <button className="rp__export-menu__item" type="button" onClick={() => onExport('pdf-executive')} data-testid="export-menu-summary-btn">
        Summary Report (.pdf)
      </button>
      <button className="rp__export-menu__item" type="button" onClick={() => onExport('pdf-complete')} data-testid="export-menu-detailed-btn">
        Detailed Report (.pdf)
      </button>
      <button className="rp__export-menu__item" type="button" onClick={() => onExport('excel')} data-testid="export-menu-full-btn">
        Full Report (.xlsx)
      </button>
    </div>,
    document.body,
  );
}
